import React, { createContext, useState, useContext, useEffect } from 'react';
import { ArticleContext } from './articleContext';
import { isArticleActive } from '~/helpers/article';

const AccordionContext = createContext();

const AccordionContextProvider = ({ accordionArticle, children }) => {
  const { article } = useContext(ArticleContext);
  const [accordionOpened, setAccordionOpened] = useState(() => isArticleActive(accordionArticle, article));

  useEffect(() => {
    setAccordionOpened(isArticleActive(accordionArticle, article));
  }, [article.path]);

  return (
    <AccordionContext.Provider value={{
      accordionOpened,
      toggleAccordion: () => setAccordionOpened(!accordionOpened)
    }}
    >
      {children}
    </AccordionContext.Provider>
  );
};

const AccordionContextConsumer = AccordionContext.Consumer;

export { AccordionContextProvider, AccordionContextConsumer, AccordionContext };
